import InvoiceList from "@/components/payment/InvoiceList";
import PaymentHistory from "@/components/payment/PaymentHistory";
import PaymentProcessing from "@/components/payment/PaymentProcessing";
import PaymentResults from "@/components/payment/PaymentResults";
import { Button } from "@/components/ui/Button";
import { PaymentProvider, usePayment } from "@/hooks/usePayment";
import * as shared from "@/styles/shared";
import { PaymentFlowStatus } from "@shared/types/payment";
import { ChevronLeft, DollarSign, History } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as styles from "./PaymentPage.styles";

const PaymentPageHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const { t: tp } = useTranslation("payment");
  return (
    <div className={shared.stickyHeader}>
      <div className={shared.rowGap3}>
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className={styles.backBtn}>
          <ChevronLeft className="h-4 w-4" />
          {t("scraping.back")}
        </Button>
        <div className={shared.rowGap3}>
          <DollarSign className={styles.titleIcon} />
          <h1 className={styles.pageTitle}>{tp("pageTitle")}</h1>
        </div>
      </div>
    </div>
  );
};

const PaymentPageBody = () => {
  const { paymentStatus } = usePayment();

  return (
    <div className={styles.bodyInner}>
      {paymentStatus !== PaymentFlowStatus.IDLE && <PaymentProcessing />}
      {paymentStatus === PaymentFlowStatus.IDLE && (
        <>
          <InvoiceList />
          <PaymentResults />
        </>
      )}
    </div>
  );
};

const PaymentPageContent = () => {
  const [showHistory, setShowHistory] = useState(false);
  const { t: tp } = useTranslation("payment");

  return (
    <div className={shared.pageFill}>
      <PaymentPageHeader />
      <div className={styles.bodyContainer}>
        <div className={styles.mainColumn}>
          <PaymentPageBody />
        </div>
        <div className={styles.historyPanel}>
          <PaymentHistory />
        </div>
      </div>

      <div className={styles.mobileHistoryBar}>
        <Button variant="outline" onClick={() => setShowHistory(true)} className="w-full">
          <History className={styles.icon} />
          {tp("paymentHistory")}
        </Button>
      </div>

      {showHistory && (
        <div className={styles.historyOverlay} onClick={() => setShowHistory(false)}>
          <div className={styles.historySheet} onClick={(e) => e.stopPropagation()}>
            <div className={styles.historySheetHeader}>
              <h2 className={styles.title}>{tp("paymentHistory")}</h2>
              <Button variant="ghost" size="sm" onClick={() => setShowHistory(false)}>
                {tp("historyClose")}
              </Button>
            </div>
            <div className={styles.sheetContent}>
              <PaymentHistory />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const PaymentPage = () => (
  <PaymentProvider>
    <PaymentPageContent />
  </PaymentProvider>
);

export { PaymentPage, PaymentPageBody, PaymentPageContent, PaymentPageHeader };
export default PaymentPage;
